document.addEventListener('DOMContentLoaded', function() {
  const ENABLE_SUBSCRIPTIONS = false; // Set this to true to re-enable subscriptions

  // Extract pack size from variant text (moved outside subscription block)
  const getPackSize = (variantText) => {
    //const match = variantText.match(/(\d+)\s*Pairs/i); sometimes it doesn't contain S it's just 1 Pair
    const match = variantText.match(/(\d+)\s*Pair/i);
    return match ? parseInt(match[1]) : null;
  };

  // Add a function to check if it's the Ultimate package
  const isUltimatePackage = (variantText) => {
    return variantText.toLowerCase().includes('ultimate');
  };

  // Update Firefly title based on pack size
  const updateFireflyTitle = (packSize, variantTitle) => {
    const productNames = document.querySelectorAll('.whats-included__name');
    productNames.forEach(nameElement => {
      if (nameElement.dataset.isFireflyDevice === 'true') {
        const deviceCount = packSize * 2;
        const strongElement = nameElement.querySelector('strong');
        
        // Add fade out
        strongElement.style.opacity = '0';
        strongElement.style.transition = 'opacity 0.3s ease';
        
        // Update text and fade in after a small delay
        setTimeout(() => {
          strongElement.textContent = packSize === 1 ? 
            `1 Pair of Firefly Devices (2 Total)` :
            `${packSize} Pairs of Firefly Devices (${deviceCount} Total)`;
          strongElement.style.opacity = '1';
        }, 300);
      } else if (nameElement.dataset.isFireflyCase === 'true') {
        // Handle case visibility
        const isUltimate = isUltimatePackage(variantTitle);
        nameElement.closest('.whats-included__row').style.display = isUltimate ? 'grid' : 'none';
      } else {
        // Update strap count based on package type
        const strongElement = nameElement.querySelector('strong');
        const isUltimate = isUltimatePackage(variantTitle);
        
        strongElement.style.opacity = '0';
        strongElement.style.transition = 'opacity 0.3s ease';
        
        setTimeout(() => {
          strongElement.textContent = isUltimate ? 
            '1 Pair of Accessory Straps (2 Total)' : 
            '1 Pair of Accessory Straps (2 Total)';
          strongElement.style.opacity = '1';
        }, 300);
      }
    });
  };

  // Replace the formatMoney function with this simpler version
  const formatMoney = (cents) => {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    
    const dollars = Math.floor(cents / 100);
    const remainingCents = cents % 100;
    
    // Pad cents with leading zero if needed
    const centsStr = remainingCents.toString().padStart(2, '0');
    
    // Format with commas for thousands
    const dollarsStr = dollars.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    
    return `$${dollarsStr}.${centsStr}`;
  };

  // Update the updateTotalSavings function
  const updateTotalSavings = (variant) => {
    const totalSavingsElement = document.querySelector('.total-savings');
    if (!totalSavingsElement) return;
    
    const savingsValueElement = totalSavingsElement.querySelector('.total-savings__value');
    
    if (variant && variant.compare_at_price && variant.compare_at_price > variant.price) {
      const savings = variant.compare_at_price - variant.price;
      savingsValueElement.innerHTML = formatMoney(savings);
      
      totalSavingsElement.style.display = 'block';
      totalSavingsElement.style.opacity = '0';
      totalSavingsElement.style.transition = 'opacity 0.3s ease';
      
      requestAnimationFrame(() => {
        totalSavingsElement.style.opacity = '1';
      });
    } else {
      totalSavingsElement.style.display = 'none';
    }
  };

  // Listen for variant changes (moved outside subscription block)
  document.addEventListener('change', function(event) {
    if (event.target.matches('.original-selector')) {
      const variantSelect = event.target;
      const currentVariant = JSON.parse(document.getElementById('ProductJson-' + variantSelect.closest('[data-product-id]').dataset.productId).innerHTML)
        .variants.find(v => v.id === parseInt(variantSelect.value));
      
      // Update pack size based on current variant
      const packSize = getPackSize(currentVariant.title);
      if (packSize) {
        updateFireflyTitle(packSize, currentVariant.title);
      }
      
      // Add this line to update total savings
      updateTotalSavings(currentVariant);
    }
  });

  // Initial setup (moved outside subscription block)
  const variantSelect = document.querySelector('.original-selector');
  if (variantSelect) {
    const currentVariant = JSON.parse(document.getElementById('ProductJson-' + variantSelect.closest('[data-product-id]').dataset.productId).innerHTML)
      .variants.find(v => v.id === parseInt(variantSelect.value));
    const packSize = getPackSize(currentVariant.title);
    if (packSize) {
      updateFireflyTitle(packSize, currentVariant.title);
    }
    
    // Add this line to initialize total savings
    updateTotalSavings(currentVariant);
  }

  if (ENABLE_SUBSCRIPTIONS) {
    const purchaseButtons = document.querySelectorAll('.purchase-option-btn');
    const purchaseOptionInput = document.getElementById('purchase-option-input');
    const purchaseOptions = document.querySelector('.purchase-options');
    const sellingPlanSelector = document.querySelector('.selling-plan-selector');
    const sellingPlanSelect = document.getElementById('selling-plan-select');
    
    if (!purchaseOptions) return;

    // Get subscription data from DOM
    const subscriptionVariants = purchaseOptions.dataset.subscriptionVariants
      ? purchaseOptions.dataset.subscriptionVariants.split(',').filter(Boolean).map(Number)
      : [];
    const sellingPlanId = purchaseOptions.dataset.sellingPlanId;

    // Function to update price display
    const updatePriceDisplay = (variant, isSubscription) => {
      const addToCartButton = document.querySelector('.product-purchase-form .button');
      if (!addToCartButton || !variant) return;

      let price = variant.price;
      if (isSubscription) {
        // Find the selected selling plan price
        const sellingPlanAllocation = variant.selling_plan_allocations.find(
          allocation => allocation.selling_plan_id === sellingPlanSelect.value
        );
        if (sellingPlanAllocation) {
          price = sellingPlanAllocation.price;
        } else {
          // Default to 15% off if no specific selling plan price found
          price = variant.price * 0.85;
        }
      }

      // Update the price in the add to cart button
      const priceElement = addToCartButton.querySelector('.current-price');
      if (priceElement) {
        priceElement.innerHTML = formatMoney(price);
      }
    };

    // Function to check if subscription is currently selected
    const isSubscriptionSelected = () => {
      return document.querySelector('.purchase-option-btn[data-purchase-type="subscribe"][aria-pressed="true"]') !== null;
    };

    // Function to update selling plan in form
    const updateSellingPlan = (isSubscription) => {
      const form = document.querySelector('.product-purchase-form');
      if (!form) return;

      // Remove any existing selling plan inputs
      const existingInput = form.querySelector('input[name="selling_plan"]');
      if (existingInput) {
        existingInput.remove();
      }

      if (isSubscription && sellingPlanSelect) {
        // Create and add new selling plan input
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'selling_plan';
        input.value = sellingPlanSelect.value;
        form.appendChild(input);
      }
    };

    // Handle purchase option selection
    purchaseButtons.forEach(button => {
      button.addEventListener('click', function() {
        // Update button states
        purchaseButtons.forEach(btn => btn.setAttribute('aria-pressed', 'false'));
        this.setAttribute('aria-pressed', 'true');

        const isSubscription = this.dataset.purchaseType === 'subscribe';
        
        // Show/hide selling plan selector
        if (isSubscription) {
          sellingPlanSelector.style.display = 'block';
          updateSellingPlan(true);
        } else {
          sellingPlanSelector.style.display = 'none';
          updateSellingPlan(false);
        }

        // Get current variant
        const variantSelect = document.querySelector('.original-selector');
        const currentVariant = variantSelect ? 
          JSON.parse(document.getElementById('ProductJson-' + variantSelect.closest('[data-product-id]').dataset.productId).innerHTML)
            .variants.find(v => v.id === parseInt(variantSelect.value))
          : null;

        // Update price display
        updatePriceDisplay(currentVariant, isSubscription);
      });
    });

    // Handle selling plan selection
    if (sellingPlanSelect) {
      sellingPlanSelect.addEventListener('change', function() {
        updateSellingPlan(true);
        
        // Get current variant and update price
        const variantSelect = document.querySelector('.original-selector');
        const currentVariant = variantSelect ? 
          JSON.parse(document.getElementById('ProductJson-' + variantSelect.closest('[data-product-id]').dataset.productId).innerHTML)
            .variants.find(v => v.id === parseInt(variantSelect.value))
          : null;

        updatePriceDisplay(currentVariant, true);
      });
    }

    // Also hook into theme's variant changed event
    const productForm = document.querySelector('.product-form');
    if (productForm) {
      productForm.addEventListener('variantChanged', function(event) {
        if (event.detail) {
          const isSubscription = isSubscriptionSelected();
          updatePriceDisplay(event.detail, isSubscription);
          if (isSubscription) {
            updateSellingPlan(true);
          }
        }
      });
    }

    // Initial setup
    const variantSelect = document.querySelector('.original-selector');
    if (variantSelect) {
      const currentVariant = JSON.parse(document.getElementById('ProductJson-' + variantSelect.closest('[data-product-id]').dataset.productId).innerHTML)
        .variants.find(v => v.id === parseInt(variantSelect.value));
      const isSubscription = isSubscriptionSelected();
      updatePriceDisplay(currentVariant, isSubscription);
      if (isSubscription) {
        updateSellingPlan(true);
      }
      const packSize = getPackSize(currentVariant.title);
      if (packSize) {
        updateFireflyTitle(packSize, currentVariant.title);
      }
      
      // Add this line to initialize total savings
      updateTotalSavings(currentVariant);
    }
  }

  // Pack Calculator
  const calculator = {
    currentScreen: 'goal',
    answers: {},

    init() {
      // Let theme handle modal opening/closing
      document.querySelectorAll('.modal__close').forEach(close => {
        close.addEventListener('click', () => {
          this.resetCalculator();
        });
      });

      // Option buttons
      document.querySelectorAll('.pack-calculator__option').forEach(option => {
        option.addEventListener('click', (e) => {
          const nextScreen = e.target.dataset.next;
          const value = e.target.dataset.value;
          const pack = e.target.dataset.pack;
          
          this.answers[this.currentScreen] = value;
          
          if (nextScreen === 'result') {
            this.showResult(pack);
          } else {
            this.showScreen(nextScreen);
          }
        });
      });

      // Select Pack button
      document.querySelector('.pack-calculator__select-pack').addEventListener('click', () => {
        const packSize = document.querySelector('.pack-calculator__result').dataset.packSize;
        this.selectPack(packSize);
        // Let theme handle modal closing
        document.querySelector('.modal__close').click();
        this.resetCalculator();
      });
    },

    showScreen(screenName) {
      document.querySelectorAll('.pack-calculator__screen').forEach(screen => {
        screen.style.display = 'none';
      });
      document.querySelector(`.pack-calculator__screen[data-screen="${screenName}"]`).style.display = 'block';
      this.currentScreen = screenName;
    },

    showResult(packSize) {
      const resultContent = document.querySelector('.pack-calculator__result-content');
      const resultContainer = document.querySelector('.pack-calculator__result');
      
      let explanation = '';
      switch(this.answers.goal) {
        case 'recovery':
          explanation = 'Based on your workout frequency, we recommend our';
          break;
        case 'travel':
          explanation = 'For your flight duration, we recommend our';
          break;
        case 'warmup':
          explanation = 'For your training intensity, we recommend our';
          break;
      }
      
      resultContent.innerHTML = `
        <p>${explanation}</p>
        <h3>${packSize} Pack</h3>
        <p>This will give you ${packSize * 2} devices (${packSize} pairs) to optimize your recovery.</p>
      `;
      
      resultContainer.dataset.packSize = packSize;
      this.showScreen('result');
    },

    selectPack(packSize) {
      // Find and click the corresponding variant option
      const variantOptions = document.querySelectorAll('.original-selector option');
      variantOptions.forEach(option => {
        if (option.text.includes(`${packSize} Pack`)) {
          option.selected = true;
          option.closest('select').dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    },

    resetCalculator() {
      this.currentScreen = 'goal';
      this.answers = {};
      this.showScreen('goal');
    }
  };

  // Initialize calculator
  calculator.init();
}); 